import { lighten } from "@mui/material/styles";
import { colors } from "./colors";

export const palette = {
  divider: colors.greyGradient[100],
  background: {
    paper: "#fff",
    default: "#F6F6F6",
  },
  primarylight: {
    main: colors.primary[50],
    light: colors.primary[500],
    contrastText: colors.primary.main,
    dark: lighten(colors.primary[50], 0.4),
  },
  secondarylight: {
    main: colors.secondary[350],
    light: colors.secondary.dark,
    contrastText: colors.secondary.dark,
    dark: colors.secondary.dark,
  },
  successlight: {
    main: colors.success[100],
    light: colors.success[500],
    contrastText: colors.success[600],
    dark: lighten(colors.success[50], 0.2),
  },
  errorlight: {
    main: colors.error[100],
    light: colors.error[500],
    contrastText: colors.error[600],
    dark: lighten(colors.error[50], 0.2),
  },
  warninglight: {
    main: colors.warning[100],
    light: colors.warning[500],
    contrastText: colors.warning[600],
    dark: lighten(colors.warning[50], 0.2),
  },
  infolight: {
    main: colors.info[100],
    light: colors.info[500],
    contrastText: colors.info[600],
    dark: lighten(colors.info[50], 0.2),
  },
  pinklight: {
    main: colors.pink[100],
    light: colors.pink[500],
    contrastText: colors.pink[600],
    dark: lighten(colors.pink[50], 0.2),
  },
  greylight: {
    main: colors.greyGradient[100],
    light: colors.greyGradient[500],
    contrastText: colors.greyGradient[600],
    dark: lighten(colors.greyGradient[50], 0.2),
  },
  purplelight: {
    main: colors.purple[100],
    light: colors.purple[500],
    contrastText: colors.purple[600],
    dark: lighten(colors.purple[50], 0.2),
  },
  tovalidate: {
    main: "#FFC10A66",
    light: "#FFC10A",
    contrastText: "#B89606",
    dark: lighten("#FFC10A66", 0.2),
  },
  pending: {
    main: "#E8E8EA",
    light: "#A5A3A9",
    contrastText: "#A5A3A9",
    dark: lighten("#E8E8EA", 0.2),
  },
  coming: {
    main: "#E8E8EA",
    light: "#A5A3A9",
    contrastText: "#A5A3A9",
    dark: lighten("#E8E8EA", 0.2),
  },
  accepted: {
    main: "#D2FBF0",
    light: "#18BA92",
    contrastText: "#18BA92",
    dark: lighten("#D2FBF0", 0.2),
  },
  sent: {
    main: "#D2FBF0",
    light: "#18BA92",
    contrastText: "#18BA92",
    dark: lighten("#D2FBF0", 0.2),
  },
  reserved: {
    main: "#18BA92",
    light: "#fff",
    contrastText: "#fff",
    dark: lighten("#18BA92", 0.2),
  },
  refused: {
    main: "#E01B3F80",
    light: "#fff",
    contrastText: "#fff",
    dark: lighten("#E01B3F80", 0.2),
  },
  inprogress: {
    main: "#E6ECFF",
    light: "#0030CC",
    contrastText: "#0030CC",
    dark: lighten("#E6ECFF", 0.2),
  },
  expired: {
    main: "#77757F",
    light: "#fff",
    contrastText: "#fff",
    dark: lighten("#77757F", 0.2),
  },
  completed: {
    main: "#FFC10A66",
    light: "#B89606",
    contrastText: "#B89606",
    dark: lighten("#FFC10A66", 0.2),
  },
  disputed: {
    main: "#FF9A4D66",
    light: "#CC5801",
    contrastText: "#CC5801",
    dark: lighten("#FF9A4D66", 0.2),
  },
  cancelled: {
    main: "#E01B3F80",
    light: "#fff",
    contrastText: "#fff",
    dark: lighten("#E01B3F80", 0.2),
  },
  over: {
    main: "#AE59C6",
    light: "#fff",
    contrastText: "#fff",
    dark: lighten("#AE59C6", 0.2),
  },
  transparent: {
    main: "rgba(0, 0, 0, 0.2)",
    light: "rgba(0, 0, 0, 0.2)",
    contrastText: "rgba(0, 0, 0, 1)",
    dark: "rgba(0, 0, 0, 0.4)",
  },
  primarywhite: {
    main: "#fff",
    light: colors.primary[50],
    contrastText: colors.greyGradient.light,
    dark: colors.primary[50],
  },
  white: {
    main: "#fff",
    light: "#fff",
    contrastText: "#000",
    dark: "#fff",
  },
  text: {
    primary: colors.greyGradient.main,
  },
  common: {
    white: "#fff",
    black: "#000",
  },
  footer: {
    linkColor: "white",
    socialIconColor: "white",
    dividerColor: colors.primary[350],
    bottomFooterTextColor: colors.primary[100],
  },
  ...colors,
};
